import cn from 'classnames';
import React from 'react';
import { DH } from '../../../../utils/DataHook';
import { t } from '../../../../utils/i18n';
import { Loader } from '../../../Loader';
import { AriaNode } from '../AriaNode';
import s from './styles.scss';

interface IActionButtonsProps {
  mobile: boolean;
  accessibilityLabel: string;
  isRemovingInProcess: boolean;
  requestRemoval: () => void;
  confirmRemoval: () => void;
  declineRemoval: () => void;
  showRemoveConfirmation: boolean;
  acceptButtonRef: React.RefObject<any>;
  removalButtonRef: React.RefObject<any>;
}

export class ActionButtons extends React.Component<IActionButtonsProps> {
  render() {
    const isMobileLoading = this.props.mobile && this.props.isRemovingInProcess;

    return (
      <div className={s.actionButtons} data-hook={DH.ActionButtons.Container}>
        {this.props.showRemoveConfirmation ? (
          <>
            <span
              aria-expanded={true}
              aria-label={t('app.card.details.ask-removal')}
              className={s.confirmLabel}
              id="removal-label"
            >
              {t('app.card.details.ask-removal')}
            </span>
            <AriaNode
              ref={this.props.acceptButtonRef}
              tagName="span"
              role="option"
              aria-label={`${t('app.card.details.remove')} ${t('app.card.details.accept-button')} `}
              className={s.action}
              data-hook={DH.ActionButtons.ConfirmRemoval}
              onClick={this.props.confirmRemoval}
            >
              {t('app.card.details.accept-button')}
            </AriaNode>
            <AriaNode
              tagName="span"
              role="option"
              className={s.action}
              data-hook={DH.ActionButtons.DeclineRemoval}
              onClick={this.props.declineRemoval}
              aria-label={`${t('app.card.details.remove')} ${t('app.card.details.decline-button')}`}
            >
              {t('app.card.details.decline-button')}
            </AriaNode>
          </>
        ) : (
          <AriaNode
            ref={this.props.removalButtonRef}
            tagName="span"
            role="listbox"
            className={cn(s.action, { [s.loading]: isMobileLoading })}
            data-hook={DH.ActionButtons.RequestRemoval}
            onClick={isMobileLoading ? null : this.props.requestRemoval}
            aria-expanded={this.props.showRemoveConfirmation}
            aria-label={this.props.accessibilityLabel}
          >
            {isMobileLoading && (
              <div className={s.loader}>
                <Loader size="xsmall" />
              </div>
            )}
            {isMobileLoading ? t('app.card.details.remove.loading') : t('app.card.details.remove')}
          </AriaNode>
        )}
      </div>
    );
  }
}
